export default __webpack_public_path__ + "static/event2-9999e9e35ac2ab3a2d44a184d0b4dbf2.jpg";